import axios, { AxiosError, AxiosResponse } from "axios";

interface ApiResponse {
    state: string;
    result: any;
}

export const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
    withCredentials: true
});

const handleResponse = (response: AxiosResponse<ApiResponse>) => {
    if (response !== undefined) {
        if (response && response.data.state === "success") {
            return response.data.result;
        } else {
            //error handling: try to extract error message from response, otherwise throw generic error
            const result = response.data.result;

            if (typeof result === "string") {
                throw new Error(result);
            }

            if (result && typeof result === "object" && "message" in result) {
                throw new Error((result as any).message);
            }

            throw new Error("Unknown API Error");
        }
    }
};

export const apiService = {
    get: async (url: string, config = {}) => {
        try {
            return handleResponse(await apiClient.get(url, {
                ...config,
            }));
        } catch (error) {
            console.log("Get request error: ", error);
            throw error;
        }
    },
    post: async (url: string, data: any, config = {}) => {
        try {
            return handleResponse(await apiClient.post(url, data, {
                ...config,
            }));
        } catch (error) {
            console.log("Post request error: ", error);
            throw error;
        }
    },
    put: async (url: string, data: any, config = {}) => {
        try {
            return handleResponse(await apiClient.put(url, data, {
                ...config,
            }));
        } catch (error) {
            console.log("Put request error: ", error);
            throw error;
        }
    },
    delete: async (url: string) => {
        try {
            return handleResponse(await apiClient.delete(url));
        } catch (error) {
            console.log("Delete request error: ", error);
            throw error;
        }
    }
}

export default apiService;